export const types = {
  PRODUCT_ADD_PRODUCT: "[product] ADD_PRODUCT",
  START_DOWNLOADING_PRODUCTS: "[product] START_DOWNLOADING_PRODUCTS",
  PRODUCT_DOWNLOAD_SUCCESSFULL: "[product] PRODUCT_DOWNLOAD_SUCCESSFULL",
  PRODUCT_DOWNLOAD_ERROR: "[product] PRODUCT_DOWNLOAD_ERROR",
  PRODUCT_LOAD_CURRENT_ITEM: "[product] LOAD_CURRENT_ITEM",
  PRODUCT_UPDATE: "[product] PRODUCT_UPDATE",
  PRODUCT_UPDATED_SUCCESSFULLY: "[product] PRODUCT_UPDATED_SUCCESSFULLY",
  PRODUCT_DELETE_SUCCESSFULLY: "[product] PRODUCT_DELETE_SUCCESSFULLY",
};
